import styles from '@/components/NavBar/NavBar.module.css';

export type Tab = 'home' | 'tools' | 'probe';

const TABS: { id: Tab; label: string }[] = [
  { id: 'home', label: 'Home' },
  { id: 'tools', label: 'Tools' },
  { id: 'probe', label: 'Probe' },
];

interface NavBarProps {
  active: Tab;
  onChange: (tab: Tab) => void;
}

export function NavBar({ active, onChange }: NavBarProps): JSX.Element {
  return (
    <nav className={styles.navBar} role="navigation" aria-label="Main navigation">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          className={`${styles.navTab} ${active === tab.id ? styles.navTabActive : ''}`}
          onClick={() => onChange(tab.id)}
          type="button"
          aria-current={active === tab.id ? 'page' : undefined}
        >
          {tab.label}
          {active === tab.id && <span className={styles.navTabIndicator} />}
        </button>
      ))}
    </nav>
  );
}
